<template>
  <div class="solutions-section">
    <div class="solutions-inner">
      <p class="p1">— {{ $t("home.v2.projects.eyebrow") }}</p>
      <div class="solutions-content">
        <div>
          <span class="p2">{{ $t("home.v2.projects.title1") }}</span>
          <span class="p3">{{ $t("home.v2.projects.title2") }}</span>
        </div>
        <div class="solutions-btn" @click="$router.push('/mall')">
          <p class="p4">{{ $t("home.v2.projects.viewAll") }}</p>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="solutions-img">
      <div v-for="item in listData" :key="item.id" class="solutions-item" @click="goDetail(item)">
        <div>
          <div class="solutions-img-wrap">
            <img :src="item.image" :alt="item.title" />
          </div>
          <h3 class="solutions-title">{{ item.title }}</h3>
          <p class="solutions-desc">{{ item.summary.chainInfo.issuer }}</p>
        </div>
        <div>
          <p class="p5">{{ item.summary.serviceInfo.debutEndTime }} {{ $t("home.v2.projects.end") }}</p>
          <div class="solutions-btn">
            <p>{{ $t("home.v2.projects.explore") }}</p>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SolutionsSection",
  data() {
    return {
      listData: [],
      oldPageData: {
        page: 1,
        rows: 5,
        cateCode: "goods",
        queryDeep: 1,
      },
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      this.$axios.post("/cms/getList", this.oldPageData).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          const rows = res.data.data.rows || [];
          this.listData = rows
            .slice(0, this.oldPageData.rows)
            .map((item) => ({
              ...item,
              newGoodType: 1,
              summary: JSON.parse(item.summary),
            }));
          console.log("listData", this.listData);
        }
      });
    },
    goDetail(item) {
      this.$router.push({ path: "mall/oldDetail", query: { cateCode: item.cateCode } });
    },
  },
};
</script>

<style lang="less" scoped>
.solutions-section {
  padding: 100px 60px;
  background: #ffffff;
  box-sizing: border-box;
}
.solutions-inner {
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
  }
}
.solutions-content {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .p2 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #333333;
  }
  .p3 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #E05807;
    line-height: 50px;
  }
  .p4 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
  }
  .solutions-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #333333;
    p {
      padding-bottom: 12px;
    }
    i {
      font-size: 24px;
      color: #333333;
      margin-left: 8px;
    }
  }
}

.solutions-img {
  gap: 34px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  padding-top: 48px;
  .solutions-item {
    gap: 34px;
    height: 560px;
    display: flex;
    cursor: pointer;
    border-left: none;
    background: #ffffff;
    flex-direction: column;
    border: 1px solid #dcdbd9;
    justify-content: space-between;
    .solutions-img-wrap {
      width: 100%;
      height: 332px;
      padding: 56px;
      background: rgba(0, 0, 0, 0.1);
      img {
        width: 220px;
        height: 220px;
      }
    }
    .solutions-title {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 26px;
      color: #333333;
      margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 9px;
    }
    .solutions-desc {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #999999;
      margin-left: 20px;
    }
  }
  .p5 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1f2329;
    margin-left: 20px;
    margin-bottom: 12px;
  }
  .solutions-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-left: 20px;
    margin-bottom: 32px;
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #E05807;
    }
    i {
      font-size: 12px;
      color: #E05807;
      margin-left: 8px;
    }
  }
}
</style>
